export const TYPE_SYSTEM = 1;
export const TYPE_ACTIVE = 2;
export const TYPE_LEAD = 3;
export const TYPE_SHARE = 4;
export const TYPE_DISABLED = 6;
export const TYPE_SSO_LOCKED = 7;
